module.exports = __webpack_public_path__ + "media/landing_page/hero-mobile-5-51e298be.webp";